import { useContext } from "react";
import { UserContext } from "../../context/UserContext";
import AnswerManagement from "../dropItemsManagement/AnswerManagement";
import TimeAndAnswers from "../questionPage/helper/TimeAndAnswers";
import { ANSWERS, QUESTIONS } from "../../api/Api";
import { useQuery } from "@tanstack/react-query";
import { useQuestionId } from "../../Store/QuestionSlice";
import { Axios } from "../../Axios/createAxios";
export default function AnswersBox() {
  const { userInfo } = useContext(UserContext);
  const questionId = useQuestionId();
  const fetchData = async () => {
    try {
      const res = await Axios.get(`/${QUESTIONS}/${questionId}/${ANSWERS}`);
      return res;
    } catch (err) {
      throw err;
    }
  };
  const { data, isLoading } = useQuery({
    queryKey: ["answers"],
    queryFn: fetchData,
    enabled: !!questionId,
    onError: (err) => {
      console.log(err);
    },
    retry: 2,
  });
  console.log(data?.data?.data);

  function answersBox() {
    return (
      <div className="answers-box flex-1 flow-y-auto">
        {isLoading && <div>loading.....</div>}

        {data?.data?.data.map((item, index) => {
          const answer = item.answer;
          const answerCreator = item.user.name;
          const answerId = item.id;
          const disliked = item.disliked;
          const liked = item.liked;
          const answerCreatorId = item.user_id;
          const userPoints = item.user.points;
          const createdAt = item.created_at;
          const isFeatured = item.is_featured;
          return (
            <div
              key={index}
              className={`answer-box mb-5 d-grid gap-6 ${isFeatured && "best-answer"} relative`}
              onClick={() => console.log(answerId)}>
              <header
                className="d-flex justify-content-between align-items-center pl-10 pr-10"
                style={{ borderColor: answerCreatorId === userInfo.id && "darkseagreen" }}>
                <div className="d-flex">
                  <span className="mr-10">{answerCreator}</span>
                  <span>{userPoints}xp</span>
                </div>
                <div className="relative">
                  <span className="succ-c">{liked}</span> <span className="err-c">{disliked}</span>
                  <span
                    className="absolute winer-line center-y"
                    style={{
                      background: `${
                        liked === 0 && disliked === 0
                          ? "#ddd"
                          : `linear-gradient(to right, #77b777 ${liked}0%, #cc2125 ${disliked}0%)`
                      } `,
                    }}></span>
                </div>
              </header>
              <article className="overflow-auto">
                <p className="pl-10 pr-10" style={{ whiteSpace: "pre-line", overflowWrap: "break-word" }}>
                  {answer}
                </p>
              </article>

              <footer>
                <AnswerManagement featured={isFeatured} answerId={answerId} answerCreatorId={answerCreatorId} />

                <TimeAndAnswers box="answer" time={createdAt} />
              </footer>
            </div>
          );
        })}
      </div>
    );
  }

  // return <>{Object.keys(showAnswer).length > 0 ? answersBox() : <p style={{ flex: 1 }}>no answers</p>}</>;
  return answersBox();
}
